import type { CSSProperties, ReactNode } from 'react'

import { useThemeMotion } from '../../../../animation/themeMotion'
import { resolveDynamicIslandMotion } from '../../../../lib/dynamicIsland/dynamicIslandMotion'
import type { DynamicIslandActivity } from '../../../../context/dynamicIslandTypes'
import {
  DynamicIslandActivityModuleChipStrip,
  DynamicIslandActivityModuleRail,
} from './DynamicIslandActivityModuleNav'

type Props = {
  activities: DynamicIslandActivity[]
  selectedId: string
  onSelectId: (id: string) => void
  angular: boolean
  renderContent: (activity: DynamicIslandActivity) => ReactNode
}

export function DynamicIslandActivityDetailShell({
  activities,
  selectedId,
  onSelectId,
  angular,
  renderContent,
}: Props) {
  const motionPreset = useThemeMotion()
  const islandMotion = resolveDynamicIslandMotion(motionPreset, false)
  const multiSource = activities.length > 1
  const active = activities.find((item) => item.id === selectedId) ?? activities[0] ?? null
  if (!active) return null

  return (
    <div
      className={[
        'glyphicai-dynamic-island-detail-shell',
        multiSource ? 'glyphicai-dynamic-island-detail-shell--multi' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      style={islandMotion.cssVars as CSSProperties}
    >
      {multiSource ? (
        <div className="glyphicai-dynamic-island-detail-shell__mobile-nav lg:hidden">
          <DynamicIslandActivityModuleChipStrip
            activities={activities}
            selectedId={selectedId}
            onSelectId={onSelectId}
            angular={angular}
          />
        </div>
      ) : null}

      <div className="glyphicai-dynamic-island-detail-shell__body">
        {multiSource ? (
          <aside className="glyphicai-dynamic-island-detail-shell__rail hidden lg:block">
            <DynamicIslandActivityModuleRail
              activities={activities}
              selectedId={selectedId}
              onSelectId={onSelectId}
              angular={angular}
            />
          </aside>
        ) : null}

        <div className="glyphicai-dynamic-island-detail-shell__content">
          <div className="glyphicai-dynamic-island-detail-shell__stage">
            {activities.map((activity) => (
              <div
                key={activity.id}
                className={[
                  'glyphicai-dynamic-island__pane',
                  'glyphicai-dynamic-island-detail-shell__pane',
                  activity.id === active.id ? 'glyphicai-dynamic-island__pane--active' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
                aria-hidden={activity.id !== active.id}
              >
                <div className="glyphicai-dynamic-island-detail-pane">{renderContent(activity)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
